const PaxsGroup = (state) => state.PaxsGroup

export default {
  PaxsGroup
}
